import React, { useState } from "react";
import { BiCalendar } from "react-icons/bi";
import { apiOrigin, artemulkImages } from "../../data/artemulkContent";
import "./GetInTouch.css";

const initialForm = { name: "", tel_no: "", message: "" };

const MeetingFormFields = ({
  formData,
  handleChange,
  handleSubmit,
  message,
  submitting,
  panel = false,
}) => (
  <form onSubmit={handleSubmit} className="space-y-4">
    <input
      type="text"
      name="name"
      value={formData.name}
      onChange={handleChange}
      className="meeting-field"
      placeholder="Ad Soyad"
      required
    />
    <input
      type="tel"
      name="tel_no"
      value={formData.tel_no}
      onChange={handleChange}
      className="meeting-field"
      placeholder="Telefon"
      required
    />
    <textarea
      name="message"
      value={formData.message}
      onChange={handleChange}
      className="meeting-field resize-none"
      rows={panel ? 4 : 3}
      placeholder="Görüşme konusu ve mesajınız"
      required
    />

    {message && (
      <div
        className={`meeting-alert ${
          message.includes("gönderildi") ? "meeting-alert--success" : "meeting-alert--error"
        }`}
      >
        {message}
      </div>
    )}

    <button type="submit" className="meeting-submit" disabled={submitting}>
      <span className="meeting-submit__icon">
        <BiCalendar />
      </span>
      <span>{submitting ? "Gönderiliyor…" : "Görüşme Planla"}</span>
    </button>
  </form>
);

const GetInTouch = ({ isCompact = false }) => {
  const [formData, setFormData] = useState(initialForm);
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage("");

    try {
      const response = await fetch(`${apiOrigin}/api/contactsend`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        setMessage("Görüşme talebiniz gönderildi.");
        setFormData(initialForm);
        setTimeout(() => setMessage(""), 4000);
      } else {
        setMessage("Bir hata oluştu. Lütfen tekrar deneyin.");
      }
    } catch {
      setMessage("Bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setSubmitting(false);
    }
  };

  const formProps = {
    formData,
    handleChange,
    handleSubmit,
    message,
    submitting,
  };

  if (isCompact) {
    return (
      <div className="meeting-form-card">
        <span className="sub-heading">Randevu</span>
        <h3 className="meeting-form__title">Görüşme Planlayın</h3>
        <p className="meeting-form__lead">
          Emlak, gayrimenkul ve yatırım konularında danışmanlık için görüşme talebi
          oluşturun.
        </p>
        <div className="mt-6">
          <MeetingFormFields {...formProps} />
        </div>
      </div>
    );
  }

  return (
    <div className="pt-10 pb-16">
      <div className="meeting-section grid grid-cols-1 md:grid-cols-2">
        <div className="meeting-section__media">
          <img
            src={artemulkImages.contactForm}
            alt="Arte Mülk İletişim"
            className="w-full h-full object-cover min-h-[280px] md:min-h-full"
          />
        </div>
        <div className="meeting-section__panel meeting-panel flex items-center">
          <div className="w-full max-w-[400px] mx-auto text-white">
            <span className="meeting-panel__eyebrow">Randevu</span>
            <h2 className="meeting-panel__title">Görüşme Planlayın</h2>
            <p className="meeting-panel__lead">
              Emlak, gayrimenkul ve yatırım konularında danışmanlık için bize ulaşın.
            </p>
            <div className="mt-6">
              <MeetingFormFields {...formProps} panel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
